import React from 'react';
import { FemEntityLanding } from './pages/FemEntityLanding';
import { InvestorsPage } from './pages/InvestorsPage';
import { PractitionersPage } from './pages/PractitionersPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { AppLaunchPage } from './pages/AppLaunchPage';
import { PractitionerJoinPage } from './pages/PractitionerJoinPage';
import { PractitionerWelcomePage } from './pages/PractitionerWelcomePage';
import { PractitionerPaymentSetupPage } from './pages/PractitionerPaymentSetupPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { TermsOfSalePage } from './pages/TermsOfSalePage';
export function App() {
  const path = window.location.pathname.replace(/\/+$/, '') || '/';
  if (path === '/investors') {
    return <InvestorsPage data-id="element-0" data-mp="28ufnm9e7hai0" />;
  }
  if (path === '/practitioners/join') {
    return <PractitionerJoinPage initialStep="account" data-id="element-1" data-mp="28sbad0uf2z52" />;
  }
  if (path === '/practitioners/membership') {
    return <PractitionerJoinPage initialStep="membership" data-id="element-2" data-mp="3ik7gwiph6frp" />;
  }
  if (path === '/practitioners/welcome') {
    return <PractitionerWelcomePage data-id="element-3" data-mp="3ml12v6jcxkhy" />;
  }
  if (path === '/practitioners/setup-payments') {
    return <PractitionerPaymentSetupPage data-id="element-4" data-mp="3rcj2nr9n9f1c" />;
  }
  if (path === '/terms-of-service') {
    return <TermsOfServicePage data-id="element-5" data-mp="5yhupa6n3cr" />;
  }
  if (path === '/terms-of-sale') {
    return <TermsOfSalePage data-id="element-6" data-mp="82lr78302d1" />;
  }
  if (path === '/practitioners') {
    return <PractitionersPage data-id="element-7" data-mp="2zmepackaxs9m" />;
  }
  if (path === '/privacy-policy') {
    return <PrivacyPolicyPage data-id="element-8" data-mp="33m5ck6amdq9e" />;
  }
  if (path === '/get-the-app') {
    return <AppLaunchPage data-id="element-9" data-mp="33oi0r16z0wuw" />;
  }
  return <FemEntityLanding data-id="element-10" data-mp="38l8eviz7tido" />;
}